var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeadGenerated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66667 11.0001L12.144 11.7452C13.0689 12.0283 13.7561 12.7702 13.9842 13.6733C14.0743 14.0305 13.7659 14.3334 13.3957 14.3334H2.60426C2.23405 14.3334 1.92563 14.0305 2.01583 13.6733C2.24395 12.7702 2.93106 12.0283 3.85601 11.7452L6.33333 11.0001V9.70821C5.14611 8.77901 4.33333 7.66661 4.33333 5.27783C4.33333 2.8846 5.63649 1.66663 7.66153 1.66663C9.09553 1.66663 9.69233 2.33329 9.69233 2.33329C11.3846 2.33329 11.6667 3.73142 11.6667 5.27783C11.6667 7.66661 10.8539 8.77901 9.66667 9.70821V11.0001Z",
    stroke: "#2E2C27",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadGenerated);
export default __webpack_public_path__ + "static/media/lead-generated.2b4e1f65adfeabb261be50cdba1fadf4.svg";
export { ForwardRef as ReactComponent };